import React from "react";
import SettingViewContainer from "../components/SettingViewContainer";
import VehicleConfiguration from "./VehicleConfiguration";

const VehicleConfigurationView = () => {
  return (
    <SettingViewContainer
      title="Vehicle Configuration"
      subTitle={
        "Here you can manage the strings that match these icons. Click a row to add or remove strings. You can also add a dwell time per vehicle type. This is factored in ETA & Dispatch optimization calculations as well."
      }
      divideSection={false}
    >
      <VehicleConfiguration />
    </SettingViewContainer>
  );
};

export default VehicleConfigurationView;
